import Vue from "vue";
import Message from "./index.vue";
let MessageConstructor = Vue.extend(Message);
export default function ({ title, html, confirm }) {
  return new Promise(res => {
    let messageDialog = new MessageConstructor({
      mounted() { },
      destroyed() {
        document.body.removeChild(this.$el);
        res();
      }
    });
    messageDialog.title = title;
    messageDialog.html = html;
    messageDialog.confirm = confirm;
    messageDialog.$on("dialog-leave", () => messageDialog.$destroy());
    messageDialog.$mount();
    document.body.appendChild(messageDialog.$el);
  });
}
